/**
 * Каркас: боковое меню слева, раздел справа.
 *
 * Меню знает о разделах через таблицу, а не через набор ссылок в разметке:
 * на E10 сюда доедут карты, героини, главы, сцены, медиа, гача и реплики,
 * и дописать раздел должно быть одной строкой.
 */

import type { ReactNode } from 'react'
import { hrefFor, type Route } from '../router.js'
import type { AdminAccount } from '../api/types.js'

interface NavEntry {
  route: Route
  icon: string
  title: string
  /** Какие маршруты подсвечивают этот пункт. */
  matches: Route['name'][]
}

const NAV: NavEntry[] = [
  { route: { name: 'economy' }, icon: '⚖', title: 'Economy', matches: ['economy'] },
  { route: { name: 'scenes' }, icon: '💜', title: 'Scenes', matches: ['scenes'] },
  { route: { name: 'players' }, icon: '👤', title: 'Players', matches: ['players', 'player'] },
  { route: { name: 'cheats' }, icon: '⚑', title: 'Cheat log', matches: ['cheats'] },
  { route: { name: 'generation' }, icon: '🎬', title: 'Generation', matches: ['generation'] },
]

export interface LayoutProps {
  route: Route
  admin: AdminAccount | null
  onLogout: () => void
  children: ReactNode
}

export function Layout({ route, admin, onLogout, children }: LayoutProps): JSX.Element {
  return (
    <div className="layout">
      <aside className="sidebar">
        <h1 className="sidebar__logo">
          LiveOps <span className="accent">console</span>
        </h1>

        <nav className="sidebar__nav">
          <div className="sidebar__section">Sections</div>
          {NAV.map((entry) => (
            <a
              key={entry.title}
              href={hrefFor(entry.route)}
              className={`nav-item${entry.matches.includes(route.name) ? ' nav-item--active' : ''}`}
            >
              <span className="nav-item__icon" aria-hidden>
                {entry.icon}
              </span>
              {entry.title}
            </a>
          ))}
        </nav>

        <div className="sidebar__footer">
          <div className="sidebar__admin">
            {admin?.email ?? 'admin'}
            <br />
            <span style={{ fontSize: 11 }}>admin realm, 8 h TTL</span>
          </div>
          <button className="btn btn--ghost btn--sm" type="button" onClick={onLogout}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="main">
        <div className="main__inner">{children}</div>
      </main>
    </div>
  )
}

export function PageHead({
  title,
  subtitle,
  actions,
}: {
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
}): JSX.Element {
  return (
    <header className="page-head">
      <div>
        <h1>{title}</h1>
        {subtitle !== undefined && <p>{subtitle}</p>}
      </div>
      {actions !== undefined && <div className="row">{actions}</div>}
    </header>
  )
}
